<div class="main-container" (click)="onClickCell()">
  <p class="m-0 w-100">
    <span class="tx_id">{{getTxId(systemGen && systemGen.value)}}</span>
    <span class="d-flag" [ngStyle]="{'background-color': getFlag(systemGen && systemGen.isNew) === 'New' ? '#d53811' : '#FFF'}">
        {{getFlag(systemGen && systemGen.isNew)}}
    </span>
  </p>
</div>
